// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var Common = require("../utils/Common.res.js");
var Js_exn = require("rescript/lib/js/js_exn.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var MM_cmp_api = require("./MM_cmp_api.res.js");
var MM_context = require("../mm-utils/MM_context.res.js");
var MM_provers = require("../mm-utils/MM_provers.res.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Belt_Result = require("rescript/lib/js/belt_Result.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Core__Array = require("@rescript/core/src/Core__Array.res.js");
var MM_wrk_unify = require("../worker/MM_wrk_unify.res.js");
var MM_cmp_macros = require("./MM_cmp_macros.res.js");
var MM_wrk_client = require("../worker/MM_wrk_client.res.js");
var MM_wrk_editor = require("../worker/MM_wrk_editor.res.js");
var PaginationCmp = require("../ui-utils/PaginationCmp.res.js");
var Belt_MapString = require("rescript/lib/js/belt_MapString.js");
var Expln_React_Row = require("../../rescript-utils/main/react-mui-components/Expln_React_Row.res.js");
var MM_react_common = require("../ui-utils/MM_react_common.res.js");
var MM_substitution = require("../mm-utils/MM_substitution.res.js");
var Expln_React_Menu = require("../../rescript-utils/main/react-mui-components/Expln_React_Menu.res.js");
var MM_cmp_user_stmt = require("./MM_cmp_user_stmt.res.js");
var Expln_React_Modal = require("../../rescript-utils/main/react-components/Expln_React_Modal.res.js");
var MM_editor_history = require("../worker/MM_editor_history.res.js");
var List = require("@mui/material/List").default;
var Belt_HashSetString = require("rescript/lib/js/belt_HashSetString.js");
var Expln_React_Column = require("../../rescript-utils/main/react-mui-components/Expln_React_Column.res.js");
var Expln_utils_common = require("../../rescript-utils/main/Expln_utils_common.res.js");
var MM_cmp_editor_hist = require("./MM_cmp_editor_hist.res.js");
var MM_cmp_search_asrt = require("./MM_cmp_search_asrt.res.js");
var MM_wrk_editor_json = require("../test/MM_wrk_editor_json.res.js");
var MM_wrk_search_asrt = require("../worker/MM_wrk_search_asrt.res.js");
var Static_XML_to_HTML = require("../utils/Static_XML_to_HTML.res.js");
var Paper = require("@mui/material/Paper").default;
var Expln_utils_promise = require("../../rescript-utils/main/Expln_utils_promise.res.js");
var JsxPPXReactSupportU = require("rescript/lib/js/jsxPPXReactSupportU.js");
var Local_storage_utils = require("../ui-utils/Local_storage_utils.res.js");
var MM_cmp_export_proof = require("./MM_cmp_export_proof.res.js");
var MM_cmp_substitution = require("./MM_cmp_substitution.res.js");
var XML_formatting_help = require("../utils/XML_formatting_help.res.js");
var Button = require("@mui/material/Button").default;
var MM_cmp_pe_frame_full = require("../explorer/MM_cmp_pe_frame_full.res.js");
var MM_cmp_multiline_text = require("./MM_cmp_multiline_text.res.js");
var Checkbox = require("@mui/material/Checkbox").default;
var ListItem = require("@mui/material/ListItem").default;
var MenuItem = require("@mui/material/MenuItem").default;
var MM_cmp_merge_two_stmts = require("./MM_cmp_merge_two_stmts.res.js");
var MM_cmp_save_or_discard = require("./MM_cmp_save_or_discard.res.js");
var MM_cmp_unify_bottom_up = require("./MM_cmp_unify_bottom_up.res.js");
var Add = require("@mui/icons-material/Add").default;
var Hub = require("@mui/icons-material/Hub").default;
var MM_cmp_import_from_json = require("./MM_cmp_import_from_json.res.js");
var Menu = require("@mui/icons-material/Menu").default;
var IconButton = require("@mui/material/IconButton").default;
var Logout = require("@mui/icons-material/Logout").default;
var Search = require("@mui/icons-material/Search").default;
var ListItemText = require("@mui/material/ListItemText").default;
var MM_cmp_editor_view_options = require("./MM_cmp_editor_view_options.res.js");
var MM_cmp_export_state_to_url = require("./MM_cmp_export_state_to_url.res.js");
var MM_wrk_editor_substitution = require("../worker/MM_wrk_editor_substitution.res.js");
var Restore = require("@mui/icons-material/Restore").default;
var MM_cmp_export_state_to_json = require("./MM_cmp_export_state_to_json.res.js");
var Bookmark = require("@mui/icons-material/Bookmark").default;
var ListItemButton = require("@mui/material/ListItemButton").default;
var MergeType = require("@mui/icons-material/MergeType").default;
var PlayArrow = require("@mui/icons-material/PlayArrow").default;
var ArrowUpward = require("@mui/icons-material/ArrowUpward").default;
var PriorityHigh = require("@mui/icons-material/PriorityHigh").default;
var ArrowDownward = require("@mui/icons-material/ArrowDownward").default;
var DeleteForever = require("@mui/icons-material/DeleteForever").default;
var BookmarkBorder = require("@mui/icons-material/BookmarkBorder").default;
var Expln_React_ContentWithStickyHeader = require("../../rescript-utils/main/react-components/Expln_React_ContentWithStickyHeader.res.js");
var TextRotationNone = require("@mui/icons-material/TextRotationNone").default;
var BookmarkAddOutlined = require("@mui/icons-material/BookmarkAddOutlined").default;
var BookmarkRemoveOutlined = require("@mui/icons-material/BookmarkRemoveOutlined").default;

function editorSaveStateToLocStor(state, key, tempMode) {
  if (!tempMode) {
    return Local_storage_utils.locStorWriteString(key, Expln_utils_common.stringify(MM_wrk_editor_json.editorStateToEditorStateLocStor(state)));
  }
  
}

var editorHistRegLocStorKey = "hist-reg";

var editorHistTmpLocStorKey = "hist-tmp";

function getHistLockStorKey(tempMode) {
  if (tempMode) {
    return editorHistTmpLocStorKey;
  } else {
    return editorHistRegLocStorKey;
  }
}

function histSaveToLocStor(hist, tempMode) {
  var histStr = MM_editor_history.editorHistToString(hist);
  Local_storage_utils.locStorWriteString(tempMode ? editorHistTmpLocStorKey : editorHistRegLocStorKey, histStr);
}

function histReadFromLocStor(editorState, tempMode, maxLength) {
  var histStr = Local_storage_utils.locStorReadString(tempMode ? editorHistTmpLocStorKey : editorHistRegLocStorKey);
  if (histStr === undefined) {
    return MM_editor_history.editorHistMake(editorState, maxLength);
  }
  var hist = MM_editor_history.editorHistFromString(histStr);
  if (hist.TAG === "Ok") {
    return MM_editor_history.editorHistAddSnapshot(hist._0, editorState);
  } else {
    return MM_editor_history.editorHistMake(editorState, maxLength);
  }
}

function rndIconButton(icon, onClick, active, notifyEditInTempMode, ref, title, smallBtnsOpt) {
  var smallBtns = smallBtnsOpt !== undefined ? smallBtnsOpt : false;
  return React.createElement("span", {
              ref: ref,
              title: title
            }, React.createElement(IconButton, {
                  onClick: (function (param) {
                      if (notifyEditInTempMode !== undefined) {
                        return notifyEditInTempMode(function () {
                                    onClick();
                                  });
                      } else {
                        return onClick();
                      }
                    }),
                  color: "primary",
                  style: smallBtns ? ({
                        padding: "2px"
                      }) : undefined,
                  disabled: !active,
                  children: Caml_option.some(icon)
                }));
}

var editorStateLocStorKey = "editor-state";

var lastUsedAsrtSearchTypLocStorKey = "search-asrt-typ";

function saveLastUsedTyp(ctx, typInt, tempMode) {
  if (tempMode) {
    return ;
  }
  var typStr = MM_context.ctxIntToSym(ctx, typInt);
  if (typStr !== undefined) {
    localStorage.setItem(lastUsedAsrtSearchTypLocStorKey, typStr);
    return ;
  }
  
}

function getLastUsedTyp(ctx) {
  var typStr = localStorage.getItem(lastUsedAsrtSearchTypLocStorKey);
  if (typStr !== null) {
    return MM_context.ctxSymToInt(ctx, typStr);
  }
  
}

function jsonStrOptToEditorStateLocStor(jsonStrOpt) {
  return Belt_Option.flatMap(jsonStrOpt, (function (jsonStr) {
                return Belt_Result.mapWithDefault(MM_wrk_editor_json.readEditorStateFromJsonStr(jsonStr), undefined, (function (state) {
                              return state;
                            }));
              }));
}

var previousEditingIsNotCompletedTitle = "Previous editing is not completed";

var previousEditingIsNotCompletedText = "You've attempted to edit something in the editor while the previous edit is not complete. Please complete the previous edit before starting a new one.";

var editingInTempModeTitle = "Editing in TEMP mode";

var editingInTempModeText = "You are about to edit in TEMP mode. All changes you do in TEMP mode will be erased upon closing current browser tab. If you want to continue editing in regular mode, please do the following actions: 1) use \"Export to JSON\" to copy current editor state to the clipboard; 2) open a new tab (or switch to an already opened tab) with metamath-lamp in regular mode; 3) use \"Import from JSON\" to load the copied editor state from the clipboard.";

var infoAboutGettingCompletedProof = "In order to show a completed proof please do the following: 1) Make sure the step you want to show a completed proof for is marked with a green chekmark. If it is not, try to \"unify all\"; 2) Select the step you want to show a completed proof for; 3) Select \"Show completed proof\" menu item.";

var infoAboutInliningProof = "In order to inline a proof please do the following: 1) Make sure the step you want to inline the proof for is marked with a green chekmark. If it is not, try to \"unify all\"; 2) Select the step you want to inline the proof for; 3) Select \"Inline proof\" menu item.";

function MM_cmp_editor(props) {
  var openFrameExplorer = props.openFrameExplorer;
  var setShowTabs = props.setShowTabs;
  var showTabs = props.showTabs;
  var ctxSelectorIsExpanded = props.ctxSelectorIsExpanded;
  var toggleCtxSelector = props.toggleCtxSelector;
  var tempMode = props.tempMode;
  var initialStateJsonStr = props.initialStateJsonStr;
  var addAsrtByLabel = props.addAsrtByLabel;
  var reloadCtx = props.reloadCtx;
  var preCtxData = props.preCtxData;
  var modalRef = props.modalRef;
  var match = React.useState(function () {
        return false;
      });
  var setMainMenuIsOpened = match[1];
  var mainMenuIsOpened = match[0];
  var mainMenuButtonRef = React.useRef(null);
  var match$1 = React.useState(function () {
        return false;
      });
  var setWarnedAboutTempMode = match$1[1];
  var warnedAboutTempMode = match$1[0];
  var match$2 = React.useState(function () {
        return false;
      });
  var setContIsHidden = match$2[1];
  var contIsHidden = match$2[0];
  var match$3 = React.useState(function () {
        return false;
      });
  var setShowBkmOnly = match$3[1];
  var showBkmOnly = match$3[0];
  var showBkmOnlyRef = React.useRef(showBkmOnly);
  showBkmOnlyRef.current = showBkmOnly;
  var match$4 = Local_storage_utils.useStateFromLocalStorageBool("editor-showCheckbox", true);
  var setShowCheckbox = match$4[1];
  var showCheckbox = match$4[0];
  var match$5 = Local_storage_utils.useStateFromLocalStorageBool("editor-showLabel", true);
  var setShowLabel = match$5[1];
  var showLabel = match$5[0];
  var match$6 = Local_storage_utils.useStateFromLocalStorageBool("editor-showType", true);
  var setShowType = match$6[1];
  var showType = match$6[0];
  var match$7 = Local_storage_utils.useStateFromLocalStorageBool("editor-showJstf", true);
  var setShowJstf = match$7[1];
  var showJstf = match$7[0];
  var match$8 = Local_storage_utils.useStateFromLocalStorageBool("editor-inlineMode", false);
  var setInlineMode = match$8[1];
  var inlineMode = match$8[0];
  var match$9 = Local_storage_utils.useStateFromLocalStorageBool("editor-smallBtns", false);
  var setSmallBtns = match$9[1];
  var smallBtns = match$9[0];
  var match$10 = Local_storage_utils.useStateFromLocalStorageBool("paren-autocomplete", true);
  var setParenAc = match$10[1];
  var parenAc = match$10[0];
  var match$11 = React.useState(function () {
        return MM_wrk_editor_json.createInitialEditorState(preCtxData, jsonStrOptToEditorStateLocStor(initialStateJsonStr));
      });
  var setStatePriv = match$11[1];
  var state = match$11[0];
  var match$12 = React.useState(function () {
        return histReadFromLocStor(state, tempMode, preCtxData.settingsV.val.editorHistMaxLength);
      });
  var setHistPriv = match$12[1];
  var hist = match$12[0];
  var stmtsToShow = showBkmOnly ? state.stmts.filter(function (stmt) {
          if (stmt.typ === "E" || stmt.isGoal || stmt.isBkm || MM_wrk_editor.userStmtHasAnyErrors(stmt) || stmt.labelEditMode || stmt.typEditMode || stmt.contEditMode) {
            return true;
          } else {
            return stmt.jstfEditMode;
          }
        }) : state.stmts;
  var match$13 = Local_storage_utils.useStateFromLocalStorageInt("editor-steps-per-page", 100);
  var setStepsPerPage = match$13[1];
  var stepsPerPage = Math.max(1, Math.min(match$13[0], 300));
  var numOfPages = Math.ceil(stmtsToShow.length / stepsPerPage) | 0;
  var maxPageIdx = numOfPages - 1 | 0;
  var match$14 = React.useState(function () {
        return 0;
      });
  var setPageIdx = match$14[1];
  var pageIdx = Math.max(0, Math.min(match$14[0], maxPageIdx));
  var stmtBeginIdx = Math.imul(pageIdx, stepsPerPage);
  var stmtEndIdx = (stmtBeginIdx + stepsPerPage | 0) - 1 | 0;
  var actSetStepsPerPage = function (newStepsPerPage) {
    if (1 <= newStepsPerPage && newStepsPerPage <= 300) {
      return setStepsPerPage(function (param) {
                  return newStepsPerPage;
                });
    }
    
  };
  var actGoToPage = function (pageIdx) {
    setPageIdx(function (param) {
          return pageIdx;
        });
  };
  var setHist = function (update) {
    setHistPriv(function (ht) {
          var ht$1 = update(ht);
          histSaveToLocStor(ht$1, tempMode);
          return ht$1;
        });
  };
  var scheduleUnifyAllIfAllowed = function (st) {
    if (!st.settings.autoUnifyAll) {
      return st;
    }
    var match = st.nextAction;
    if (match !== undefined) {
      return st;
    }
    var editIsActive = MM_wrk_editor.isEditMode(st);
    var thereAreCriticalErrorsInEditor = MM_wrk_editor.editorStateHasCriticalErrors(st);
    var atLeastOneStmtIsChecked = st.checkedStmtIds.length !== 0;
    var proofStatusIsMissing = st.stmts.some(function (stmt) {
          if (stmt.typ === "P") {
            return Belt_Option.isNone(stmt.proofStatus);
          } else {
            return false;
          }
        });
    if (!editIsActive && !thereAreCriticalErrorsInEditor && !atLeastOneStmtIsChecked && proofStatusIsMissing) {
      return MM_wrk_editor.setNextAction(st, {
                  TAG: "UnifyAll",
                  nextAction: (function () {
                      
                    })
                });
    } else {
      return st;
    }
  };
  var saveStateToLocStorAndMakeHistSnapshot = function (st) {
    editorSaveStateToLocStor(st, editorStateLocStorKey, tempMode);
    setHist(function (ht) {
          return MM_editor_history.editorHistAddSnapshot(ht, st);
        });
    return st;
  };
  var setState = function (update) {
    setStatePriv(function (st) {
          var st$1 = update(st);
          var st$2 = MM_wrk_editor.verifyEditorState(st$1);
          var st$3 = saveStateToLocStorAndMakeHistSnapshot(st$2);
          return scheduleUnifyAllIfAllowed(st$3);
        });
  };
  var actUnifyAllResultsAreReady = function (proofTreeDto, nextAction) {
    setStatePriv(function (st) {
          var st$1 = MM_wrk_editor.applyUnifyAllResults(st, proofTreeDto);
          var st$2 = saveStateToLocStorAndMakeHistSnapshot(st$1);
          return MM_wrk_editor.setNextAction(st$2, {
                      TAG: "Action",
                      _0: nextAction
                    });
        });
  };
  var showInfoMsg = function (title, text) {
    MM_react_common.openInfoDialog(modalRef, text, undefined, undefined, undefined, title);
  };
  var showErrMsg = function (title, text) {
    MM_react_common.openInfoDialog(modalRef, text, undefined, Caml_option.some(React.createElement("span", {
                  style: {
                    color: "red"
                  }
                }, React.createElement(PriorityHigh, {}))), undefined, title);
  };
  var notifyEditInTempMode = function ($$continue) {
    if (tempMode && !warnedAboutTempMode) {
      return MM_react_common.openInfoDialog(modalRef, editingInTempModeText, undefined, undefined, (function () {
                    setWarnedAboutTempMode(function (param) {
                          return true;
                        });
                    $$continue();
                  }), editingInTempModeTitle);
    } else {
      return $$continue();
    }
  };
  var editIsActive = MM_wrk_editor.isEditMode(state);
  var thereAreCriticalErrorsInEditor = MM_wrk_editor.editorStateHasCriticalErrors(state);
  var thereAreAnyErrorsInEditor = MM_wrk_editor.editorStateHasAnyErrors(state);
  var atLeastOneStmtIsChecked = state.checkedStmtIds.length !== 0;
  var atLeastOneStmtHasSelectedText = Belt_Option.isSome(state.stmts.find(function (stmt) {
            return MM_wrk_editor.hasSelectedText(stmt.cont);
          }));
  var checkedStmtIds = state.checkedStmtIds.map(function (param) {
        return param[0];
      });
  var allCheckedStmtsAreBookmarked = state.stmts.every(function (stmt) {
        if (checkedStmtIds.includes(stmt.id)) {
          return stmt.isBkm;
        } else {
          return true;
        }
      });
  var allCheckedStmtsAreUnbookmarked = state.stmts.every(function (stmt) {
        if (checkedStmtIds.includes(stmt.id)) {
          return !stmt.isBkm;
        } else {
          return true;
        }
      });
  var atLeastOneStmtIsNotChecked = state.stmts.length !== state.checkedStmtIds.length;
  var mainCheckboxState = (atLeastOneStmtIsChecked || atLeastOneStmtHasSelectedText) && atLeastOneStmtIsNotChecked ? undefined : (
      atLeastOneStmtIsChecked && !atLeastOneStmtIsNotChecked ? true : false
    );
  var generalModificationActionIsEnabled = !editIsActive && !thereAreCriticalErrorsInEditor;
  var stmt = MM_wrk_editor.getTheOnlyCheckedStmt(state);
  var singleProvableChecked = stmt !== undefined && stmt.typ === "P" ? stmt : undefined;
  var numOfCheckedStmts = state.checkedStmtIds.length;
  var thereIsDuplicatedStmt = MM_wrk_editor.editorStateHasDuplicatedStmts(state);
  var actPreCtxDataUpdated = function () {
    setState(function (st) {
          var st$1 = MM_wrk_editor.setPreCtxData(st, preCtxData);
          return MM_wrk_editor.setNextAction(st$1, {
                      TAG: "Action",
                      _0: (function () {
                          
                        })
                    });
        });
    setHist(function (__x) {
          return MM_editor_history.editorHistSetMaxLength(__x, preCtxData.settingsV.val.editorHistMaxLength);
        });
  };
  React.useEffect((function () {
          actPreCtxDataUpdated();
        }), [
        preCtxData.settingsV.ver,
        preCtxData.ctxV.ver
      ]);
  var actOpenMainMenu = function () {
    setMainMenuIsOpened(function (param) {
          return true;
        });
  };
  var actCloseMainMenu = function () {
    setMainMenuIsOpened(function (param) {
          return false;
        });
  };
  var actAddNewStmt = function () {
    setState(function (st) {
          return MM_wrk_editor.addNewStmt(st, undefined, showBkmOnly)[0];
        });
  };
  var actDeleteCheckedStmts = function () {
    Expln_utils_promise.promiseMap(Expln_React_Modal.openModal(modalRef, (function () {
                return null;
              })), (function (modalId) {
            Expln_React_Modal.updateModal(modalRef, modalId, (function () {
                    var numOfSelectedStmts = state.checkedStmtIds.length;
                    return React.createElement(Paper, {
                                style: {
                                  padding: "10px"
                                },
                                children: Caml_option.some(React.createElement(Expln_React_Column.make, {
                                          spacing: 1,
                                          children: Caml_option.some(null)
                                        }, numOfSelectedStmts === state.stmts.length ? "Delete all steps?" : (
                                            numOfSelectedStmts === 1 ? "Delete the selected step?" : "Delete " + String(state.checkedStmtIds.length) + " selected steps?"
                                          ), React.createElement(Expln_React_Row.make, {
                                              children: Caml_option.some(null)
                                            }, React.createElement(Button, {
                                                  onClick: (function (param) {
                                                      Expln_React_Modal.closeModal(modalRef, modalId);
                                                    }),
                                                  children: "Cancel"
                                                }), React.createElement(Button, {
                                                  onClick: (function (param) {
                                                      Expln_React_Modal.closeModal(modalRef, modalId);
                                                      setState(MM_wrk_editor.deleteCheckedStmts);
                                                    }),
                                                  variant: "contained",
                                                  children: "Delete"
                                                }))))
                              });
                  }));
          }));
  };
  var actToggleMainCheckbox = function () {
    var action = mainCheckboxState !== undefined && !mainCheckboxState ? MM_wrk_editor.checkAllStmts : MM_wrk_editor.uncheckAllStmts;
    setStatePriv(function (st) {
          var st$1 = action(st);
          return scheduleUnifyAllIfAllowed(st$1);
        });
  };
  var actMoveCheckedStmtsUp = function () {
    setState(function (__x) {
          return MM_wrk_editor.moveCheckedStmts(__x, true);
        });
  };
  var actMoveCheckedStmtsDown = function () {
    setState(function (__x) {
          return MM_wrk_editor.moveCheckedStmts(__x, false);
        });
  };
  var actBookmarkCheckedStmts = function () {
    setStatePriv(function (st) {
          var st$1 = MM_wrk_editor.bookmarkCheckedStmts(st, true);
          return saveStateToLocStorAndMakeHistSnapshot(st$1);
        });
  };
  var actUnbookmarkCheckedStmts = function () {
    setStatePriv(function (st) {
          var st$1 = MM_wrk_editor.bookmarkCheckedStmts(st, false);
          return saveStateToLocStorAndMakeHistSnapshot(st$1);
        });
  };
  var actDuplicateStmt = function (top) {
    setState(function (st) {
          var st$1 = MM_wrk_editor.duplicateCheckedStmt(st, top);
          return MM_wrk_editor.uncheckAllStmts(st$1);
        });
  };
  var addStmtAbove = function (st, id, text, isBkm) {
    var st$1 = MM_wrk_editor.uncheckAllStmts(st);
    var st$2 = MM_wrk_editor.toggleStmtChecked(st$1, id);
    var match = MM_wrk_editor.addNewStmt(st$2, undefined, isBkm);
    return MM_wrk_editor.setStmtCont(match[0], match[1], MM_wrk_editor.strToCont(text, undefined, undefined));
  };
  var actBeginEdit0 = function (setter) {
    notifyEditInTempMode(function () {
          if (editIsActive) {
            return MM_react_common.openInfoDialog(modalRef, previousEditingIsNotCompletedText, undefined, undefined, undefined, previousEditingIsNotCompletedTitle);
          } else {
            return setState(setter);
          }
        });
  };
  var actBeginEdit = function (setter, stmtId) {
    notifyEditInTempMode(function () {
          if (editIsActive) {
            return MM_react_common.openInfoDialog(modalRef, previousEditingIsNotCompletedText, undefined, undefined, undefined, previousEditingIsNotCompletedTitle);
          } else {
            return setState(function (__x) {
                        return setter(__x, stmtId);
                      });
          }
        });
  };
  var actDescrEditComplete = function (newText) {
    setState(function (__x) {
          return MM_wrk_editor.completeDescrEditMode(__x, newText);
        });
  };
  var actVarsEditComplete = function (newText) {
    setState(function (__x) {
          return MM_wrk_editor.completeVarsEditMode(__x, newText);
        });
  };
  var actDisjEditComplete = function (newText) {
    setState(function (__x) {
          return MM_wrk_editor.completeDisjEditMode(__x, newText);
        });
  };
  var actCompleteEditLabel = function (stmtId, newLabel) {
    var newLabel$1 = newLabel.trim();
    var msg = MM_wrk_editor.renameStmt(state, stmtId, newLabel$1);
    if (msg.TAG !== "Ok") {
      return MM_react_common.openInfoDialog(modalRef, "Cannot rename this step: " + msg._0, undefined, undefined, undefined, undefined);
    }
    var st = msg._0;
    setState(function (param) {
          return MM_wrk_editor.completeLabelEditMode(st, stmtId, newLabel$1);
        });
  };
  var actToggleParenAc = function () {
    setParenAc(function (prev) {
          return !prev;
        });
  };
  var addNewStatementsPriv = function (st, stmtsDto) {
    return MM_wrk_editor.addNewStatements(st, stmtsDto, showBkmOnlyRef.current);
  };
  React.useEffect((function () {
          addAsrtByLabel.current = (function (label) {
              return new Promise((function (resolve, param) {
                            setState(function (st) {
                                  var wrkCtx = st.wrkCtx;
                                  if (wrkCtx !== undefined) {
                                    var wrkCtx$1 = Caml_option.valFromOption(wrkCtx);
                                    var frame = MM_context.getFrame(wrkCtx$1, label);
                                    if (frame !== undefined) {
                                      var st$1 = addNewStatementsPriv(st, MM_wrk_search_asrt.frameToStmtsDto(wrkCtx$1, frame));
                                      resolve({
                                            TAG: "Ok",
                                            _0: undefined
                                          });
                                      return st$1;
                                    }
                                    resolve({
                                          TAG: "Error",
                                          _0: "Cannot find a frame by name '" + label + "'"
                                        });
                                    return st;
                                  }
                                  resolve({
                                        TAG: "Error",
                                        _0: "MM context is not loaded."
                                      });
                                  return st;
                                });
                          }));
            });
        }), []);
  var actRestorePrevState = function (histIdx) {
    notifyEditInTempMode(function () {
          var msg = MM_editor_history.restoreEditorStateFromSnapshot(state, hist, histIdx);
          if (msg.TAG !== "Ok") {
            return MM_react_common.openInfoDialog(modalRef, msg._0, undefined, undefined, undefined, "Could not restore editor state");
          }
          var editorState = msg._0;
          setState(function (param) {
                return MM_wrk_editor.recalcWrkColors(editorState);
              });
        });
  };
  var viewOptions = {
    showCheckbox: showCheckbox,
    showLabel: showLabel,
    showType: showType,
    showJstf: showJstf,
    inlineMode: inlineMode,
    smallBtns: smallBtns
  };
  var actOpenRestorePrevStateDialog = function () {
    Expln_utils_promise.promiseMap(Expln_React_Modal.openModalFullScreen(modalRef, (function () {
                return null;
              })), (function (modalId) {
            Expln_React_Modal.updateModal(modalRef, modalId, (function () {
                    return React.createElement(MM_cmp_editor_hist.make, {
                                modalRef: modalRef,
                                editorState: MM_wrk_editor.removeAllTempData(state),
                                hist: hist,
                                onClose: (function () {
                                    Expln_React_Modal.closeModal(modalRef, modalId);
                                  }),
                                viewOptions: viewOptions,
                                stepsPerPage: stepsPerPage,
                                onRestore: (function (histIdx) {
                                    actRestorePrevState(histIdx);
                                    Expln_React_Modal.closeModal(modalRef, modalId);
                                  })
                              });
                  }));
          }));
  };
  var actMergeStmts = function () {
    var msg = MM_wrk_editor.findStmtsToMerge(state);
    if (msg.TAG !== "Ok") {
      return MM_react_common.openInfoDialog(modalRef, msg._0, undefined, undefined, undefined, undefined);
    }
    var match = msg._0;
    var stmt2 = match[1];
    var stmt1 = match[0];
    Expln_utils_promise.promiseMap(Expln_React_Modal.openModal(modalRef, (function () {
                return null;
              })), (function (modalId) {
            Expln_React_Modal.updateModal(modalRef, modalId, (function () {
                    return React.createElement(MM_cmp_merge_two_stmts.make, {
                                stmt1: stmt1,
                                stmt2: stmt2,
                                onCancel: (function () {
                                    Expln_React_Modal.closeModal(modalRef, modalId);
                                  }),
                                onStmtSelected: (function (stmtToUse, stmtToRemove) {
                                    Expln_React_Modal.closeModal(modalRef, modalId);
                                    var continueMergingStmts = numOfCheckedStmts === 0;
                                    setState(function (st) {
                                          var st$1 = MM_wrk_editor.mergeStmts(st, stmtToUse.id, stmtToRemove.id);
                                          if (st$1.TAG === "Ok") {
                                            var st$2 = MM_wrk_editor.uncheckAllStmts(st$1._0);
                                            if (!continueMergingStmts) {
                                              return st$2;
                                            }
                                            var st$3 = MM_wrk_editor.verifyEditorState(st$2);
                                            if (MM_wrk_editor.editorStateHasDuplicatedStmts(st$3)) {
                                              return MM_wrk_editor.setNextAction(st$3, "MergeNextDuplicate");
                                            } else {
                                              return st$3;
                                            }
                                          }
                                          MM_react_common.openInfoDialog(modalRef, st$1._0, undefined, undefined, undefined, undefined);
                                          return st;
                                        });
                                  })
                              });
                  }));
          }));
  };
  var actSearchAsrt = function () {
    var wrkCtx = state.wrkCtx;
    if (wrkCtx === undefined) {
      return ;
    }
    var wrkCtx$1 = Caml_option.valFromOption(wrkCtx);
    Expln_utils_promise.promiseMap(Expln_React_Modal.openModal(modalRef, (function () {
                return null;
              })), (function (modalId) {
            Expln_React_Modal.updateModal(modalRef, modalId, (function () {
                    return React.createElement(MM_cmp_search_asrt.make, {
                                modalRef: modalRef,
                                settingsVer: state.settingsV,
                                settings: state.settings,
                                preCtxVer: state.preCtxV,
                                preCtx: state.preCtx,
                                varsText: state.varsText,
                                disjText: state.disjText,
                                wrkCtx: wrkCtx$1,
                                frms: state.frms,
                                initialTyp: getLastUsedTyp(state.preCtx),
                                onTypChange: (function (__x) {
                                    saveLastUsedTyp(state.preCtx, __x, tempMode);
                                  }),
                                onCanceled: (function () {
                                    Expln_React_Modal.closeModal(modalRef, modalId);
                                  }),
                                onResultsSelected: (function (selectedResults) {
                                    Expln_React_Modal.closeModal(modalRef, modalId);
                                    setState(function (st) {
                                          return Core__Array.reduce(selectedResults, st, (function (st, stmtsDto) {
                                                        return addNewStatementsPriv(st, stmtsDto);
                                                      }));
                                        });
                                  })
                              });
                  }));
          }));
  };
  var getSelectionText = function (stmt) {
    var match = stmt.cont;
    if (match.TAG === "Text") {
      return ;
    }
    var clickedNodeId = match._0.clickedNodeId;
    if (clickedNodeId === undefined) {
      return ;
    }
    var time = clickedNodeId[1];
    return Belt_Option.map(MM_wrk_editor.getSelectedText(stmt.cont), (function (str) {
                  return [
                          str,
                          time
                        ];
                }));
  };
  var getExprsToSubstitute = function (st) {
    var selections = Expln_utils_common.sortInPlaceWith(st.stmts.map(function (stmt) {
                  var res = getSelectionText(stmt);
                  if (res !== undefined) {
                    return res;
                  } else {
                    return Belt_Option.map(st.checkedStmtIds.find(function (param) {
                                    return param[0] === stmt.id;
                                  }), (function (param) {
                                  return [
                                          MM_wrk_editor.contToStr(stmt.cont),
                                          param[1]
                                        ];
                                }));
                  }
                }).filter(Belt_Option.isSome).map(Belt_Option.getExn), (function (param, param$1) {
            return Common.compareDates(param[1], param$1[1]);
          }));
    var len = selections.length;
    var sel1 = Belt_Option.map(Belt_Array.get(selections, len - 2 | 0), (function (param) {
            return param[0];
          }));
    var sel2 = Belt_Option.map(Belt_Array.get(selections, len - 1 | 0), (function (param) {
            return param[0];
          }));
    if (len !== 0) {
      if (len !== 1) {
        return [
                sel1,
                sel2
              ];
      } else {
        return [
                sel2,
                undefined
              ];
      }
    } else {
      return [
              undefined,
              undefined
            ];
    }
  };
  var actSubstitute = function () {
    var wrkCtx = state.wrkCtx;
    if (wrkCtx === undefined) {
      return ;
    }
    var wrkCtx$1 = Caml_option.valFromOption(wrkCtx);
    var match = getExprsToSubstitute(state);
    var expr2Init = match[1];
    var expr1Init = match[0];
    Expln_utils_promise.promiseMap(Expln_React_Modal.openModal(modalRef, (function () {
                return null;
              })), (function (modalId) {
            Expln_React_Modal.updateModal(modalRef, modalId, (function () {
                    return React.createElement(MM_cmp_substitution.make, {
                                modalRef: modalRef,
                                editorState: state,
                                expr1Init: expr1Init,
                                expr2Init: expr2Init,
                                wrkCtx: wrkCtx$1,
                                onCanceled: (function () {
                                    Expln_React_Modal.closeModal(modalRef, modalId);
                                  }),
                                onSubstitutionSelected: (function (wrkSubs) {
                                    Expln_React_Modal.closeModal(modalRef, modalId);
                                    setState(function (st) {
                                          return MM_wrk_editor_substitution.applySubstitutionForEditor(st, wrkSubs);
                                        });
                                  })
                              });
                  }));
          }));
  };
  var makeActTerminate = function (modalId) {
    return function () {
      MM_wrk_client.terminateWorker();
      Expln_React_Modal.closeModal(modalRef, modalId);
    };
  };
  var prepareArgs0 = function (argLabels, rootStmts) {
    return rootStmts.filter(function (stmt) {
                  return argLabels.includes(stmt.label);
                }).map(function (stmt) {
                return stmt.expr;
              });
  };
  var getArgs0AndAsrtLabel = function (checkedStmts, rootStmts) {
    if (checkedStmts.length === 0 || checkedStmts[checkedStmts.length - 1 | 0].typ !== "P") {
      return ;
    }
    var stmtToProve = checkedStmts[checkedStmts.length - 1 | 0];
    var match = MM_wrk_editor.parseJstf(stmtToProve.jstfText);
    if (match.TAG === "Ok") {
      var match$1 = match._0;
      if (match$1 !== undefined) {
        return [
                prepareArgs0(match$1.args, rootStmts),
                match$1.label
              ];
      }
      
    }
    if (checkedStmts.length === 1) {
      return ;
    } else {
      return [
              prepareArgs0(checkedStmts.slice(0, checkedStmts.length - 1 | 0).map(function (stmt) {
                        return stmt.label;
                      }), rootStmts),
              undefined
            ];
    }
  };
  var actBottomUpResultSelected = function (selectedResult, bottomUpProofResultConsumer, selectedManually) {
    if (selectedResult !== undefined) {
      return setState(function (st) {
                  var st$1 = MM_wrk_editor.addNewStatements(st, selectedResult, selectedManually && showBkmOnly);
                  var st$2 = MM_wrk_editor.uncheckAllStmts(st$1);
                  return MM_wrk_editor.setNextAction(st$2, {
                              TAG: "UnifyAll",
                              nextAction: (function () {
                                  bottomUpProofResultConsumer(selectedResult);
                                })
                            });
                });
    } else {
      return bottomUpProofResultConsumer(undefined);
    }
  };
  var actUnify = function (stmtId, params, initialDebugLevel, isApiCallOpt, delayBeforeStartMsOpt, selectFirstFoundProofOpt, bottomUpProofResultConsumerOpt, nextActionOpt) {
    var isApiCall = isApiCallOpt !== undefined ? isApiCallOpt : false;
    var delayBeforeStartMs = delayBeforeStartMsOpt !== undefined ? delayBeforeStartMsOpt : 0;
    var selectFirstFoundProof = selectFirstFoundProofOpt !== undefined ? selectFirstFoundProofOpt : false;
    var bottomUpProofResultConsumer = bottomUpProofResultConsumerOpt !== undefined ? bottomUpProofResultConsumerOpt : (function (param) {
          
        });
    var nextAction = nextActionOpt !== undefined ? nextActionOpt : (function () {
          
        });
    if (thereAreCriticalErrorsInEditor) {
      return ;
    }
    var wrkCtx = state.wrkCtx;
    if (wrkCtx === undefined) {
      return ;
    }
    var wrkCtx$1 = Caml_option.valFromOption(wrkCtx);
    var varsText = state.varsText;
    var disjText = state.disjText;
    var state$1;
    if (stmtId !== undefined) {
      var state$2 = MM_wrk_editor.uncheckAllStmts(state);
      state$1 = MM_wrk_editor.toggleStmtChecked(state$2, stmtId);
    } else {
      state$1 = state;
    }
    var rootUserStmts = MM_wrk_editor.getRootStmtsForUnification(state$1);
    var rootStmts = rootUserStmts.map(MM_wrk_editor.userStmtToRootStmt);
    var checkedStmtIds = Belt_HashSetString.fromArray(state$1.checkedStmtIds.map(function (param) {
              return param[0];
            }));
    var checkedStmts = state$1.stmts.filter(function (stmt) {
          return Belt_HashSetString.has(checkedStmtIds, stmt.id);
        });
    if (checkedStmts.length > 0 && checkedStmts[checkedStmts.length - 1 | 0].typ === "P") {
      var initialParams;
      if (params !== undefined) {
        initialParams = params;
      } else {
        var match = getArgs0AndAsrtLabel(checkedStmts, rootStmts);
        initialParams = match !== undefined ? MM_provers.bottomUpProverParamsMakeDefault(match[1], undefined, undefined, undefined, undefined, false, match[0], undefined, undefined) : undefined;
      }
      Expln_utils_promise.promiseMap(Expln_React_Modal.openModal(modalRef, (function () {
                  return null;
                })), (function (modalId) {
              Expln_React_Modal.updateModal(modalRef, modalId, (function () {
                      return React.createElement(MM_cmp_unify_bottom_up.make, {
                                  modalRef: modalRef,
                                  settingsVer: state$1.settingsV,
                                  settings: state$1.settings,
                                  preCtxVer: state$1.preCtxV,
                                  preCtx: state$1.preCtx,
                                  frms: state$1.frms,
                                  parenCnt: state$1.parenCnt,
                                  varsText: varsText,
                                  disjText: disjText,
                                  wrkCtx: wrkCtx$1,
                                  rootStmts: rootUserStmts,
                                  reservedLabels: state$1.stmts.map(function (stmt) {
                                        return stmt.label;
                                      }),
                                  typeToPrefix: Belt_MapString.fromArray(state$1.settings.typeSettings.map(function (ts) {
                                            return [
                                                    ts.typ,
                                                    ts.prefix
                                                  ];
                                          })),
                                  initialParams: initialParams,
                                  initialDebugLevel: initialDebugLevel,
                                  apiCallStartTime: isApiCall ? Caml_option.some(new Date()) : undefined,
                                  delayBeforeStartMs: delayBeforeStartMs,
                                  selectFirstFoundProof: selectFirstFoundProof,
                                  onResultSelected: (function (newStmtsDto) {
                                      actBottomUpResultSelected(newStmtsDto, bottomUpProofResultConsumer, !selectFirstFoundProof);
                                      Expln_React_Modal.closeModal(modalRef, modalId);
                                    }),
                                  onCancel: (function () {
                                      Expln_React_Modal.closeModal(modalRef, modalId);
                                    })
                                });
                    }));
            }));
      return ;
    }
    Expln_utils_promise.promiseMap(Expln_React_Modal.openModal(modalRef, (function () {
                return MM_react_common.rndProgress("Unifying all", 0, undefined);
              })), (function (modalId) {
            Expln_React_Modal.updateModal(modalRef, modalId, (function () {
                    return MM_react_common.rndProgress("Unifying all", 0, makeActTerminate(modalId));
                  }));
            var rootStmts = rootUserStmts.map(MM_wrk_editor.userStmtToRootStmt);
            return Expln_utils_promise.promiseMap(MM_wrk_unify.unify(state$1.settingsV, state$1.settings, state$1.preCtxV, state$1.preCtx, varsText, disjText, rootStmts, undefined, state$1.settings.allowedFrms, state$1.syntaxTypes, state$1.settings.checkSyntax ? MM_wrk_editor.getAllExprsToSyntaxCheck(state$1, rootStmts) : undefined, 0, (function (msg) {
                              Expln_React_Modal.updateModal(modalRef, modalId, (function () {
                                      return MM_react_common.rndProgress(msg, undefined, makeActTerminate(modalId));
                                    }));
                            })), (function (proofTreeDto) {
                          actUnifyAllResultsAreReady(proofTreeDto, nextAction);
                          Expln_React_Modal.closeModal(modalRef, modalId);
                        }));
          }));
  };
  React.useEffect((function () {
          var action = state.nextAction;
          if (action !== undefined) {
            setStatePriv(function (__x) {
                  return MM_wrk_editor.setNextAction(__x, undefined);
                });
            if (typeof action !== "object") {
              if (MM_wrk_editor.editorStateHasDuplicatedStmts(state)) {
                actMergeStmts();
              }
              
            } else if (action.TAG === "UnifyAll") {
              actUnify(undefined, undefined, undefined, undefined, undefined, undefined, undefined, action.nextAction);
            } else {
              action._0();
            }
          }
          
        }), [state.nextAction]);
  var actExportProof = function (stmtId) {
    var match = MM_wrk_editor.generateCompressedProof(state, stmtId);
    if (match === undefined) {
      return ;
    }
    var proofTableWithoutTypes = match[2];
    var proofTableWithTypes = match[1];
    var proofText = match[0];
    Expln_utils_promise.promiseMap(Expln_React_Modal.openModal(modalRef, (function () {
                return null;
              })), (function (modalId) {
            Expln_React_Modal.updateModal(modalRef, modalId, (function () {
                    return React.createElement(MM_cmp_export_proof.make, {
                                proofText: proofText,
                                proofTableWithTypes: proofTableWithTypes,
                                proofTableWithoutTypes: proofTableWithoutTypes,
                                onClose: (function () {
                                    Expln_React_Modal.closeModal(modalRef, modalId);
                                  })
                              });
                  }));
          }));
  };
  var currGoalStmtStatus = Belt_Option.map(state.stmts.find(function (stmt) {
            return stmt.isGoal;
          }), (function (stmt) {
          return [
                  stmt.id,
                  MM_wrk_editor.contToStr(stmt.cont),
                  stmt.proofStatus
                ];
        }));
  var prevGoalStmtStatus = React.useRef([
        "",
        "NoJstf"
      ]);
  React.useEffect((function () {
          var match = state.nextAction;
          if (match === undefined && currGoalStmtStatus !== undefined) {
            var currGoalStatus = currGoalStmtStatus[2];
            var curGoalText = currGoalStmtStatus[1];
            if (currGoalStatus !== undefined) {
              var match$1 = prevGoalStmtStatus.current;
              if (currGoalStatus === "Ready" && (match$1[1] !== "Ready" || curGoalText !== match$1[0])) {
                actExportProof(currGoalStmtStatus[0]);
              }
              prevGoalStmtStatus.current = [
                curGoalText,
                currGoalStatus
              ];
            } else {
              prevGoalStmtStatus.current = [
                curGoalText,
                "NoJstf"
              ];
            }
          }
          
        }), [currGoalStmtStatus]);
  var actExportToJson = function () {
    Expln_utils_promise.promiseMap(Expln_React_Modal.openModal(modalRef, (function () {
                return null;
              })), (function (modalId) {
            Expln_React_Modal.updateModal(modalRef, modalId, (function () {
                    return React.createElement(MM_cmp_export_state_to_json.make, {
                                jsonStr: Expln_utils_common.stringify(MM_wrk_editor_json.editorStateToEditorStateLocStor(state)),
                                onClose: (function () {
                                    Expln_React_Modal.closeModal(modalRef, modalId);
                                  })
                              });
                  }));
          }));
  };
  var actExportToUrl = function () {
    Expln_utils_promise.promiseMap(Expln_React_Modal.openModal(modalRef, (function () {
                return null;
              })), (function (modalId) {
            Expln_React_Modal.updateModal(modalRef, modalId, (function () {
                    return React.createElement(MM_cmp_export_state_to_url.make, {
                                editorStateBase64: Common.strToSafeBase64(Expln_utils_common.stringify(MM_wrk_editor_json.editorStateToEditorStateLocStor(state))),
                                onClose: (function () {
                                    Expln_React_Modal.closeModal(modalRef, modalId);
                                  })
                              });
                  }));
          }));
  };
  var rndSrcDtos = function (srcs) {
    return React.createElement(Expln_React_Column.make, {
                children: Caml_option.some(srcs.map(function (src, i) {
                          var readInstr = MM_wrk_editor.readInstrFromStr(src.readInstr);
                          var tmp;
                          if (readInstr === "ReadAll") {
                            tmp = "read all";
                          } else {
                            var readInstrStr = readInstr === "StopBefore" ? "stop before" : "stop after";
                            tmp = readInstrStr + ": " + src.label;
                          }
                          return JsxPPXReactSupportU.createElementWithKey(String(i), Paper, {
                                      style: {
                                        padding: "3px"
                                      },
                                      children: Caml_option.some(React.createElement(Expln_React_Column.make, {
                                                children: Caml_option.some(null)
                                              }, src.url, tmp))
                                    });
                        }))
              });
  };
  var loadEditorStatePriv = function (stateLocStor) {
    setPageIdx(function (param) {
          return 0;
        });
    setState(function (param) {
          return MM_wrk_editor.setNextAction(MM_wrk_editor_json.createInitialEditorState(preCtxData, stateLocStor), {
                      TAG: "Action",
                      _0: (function () {
                          
                        })
                    });
        });
    Belt_Option.forEach(Caml_option.nullable_to_opt(reloadCtx.current), (function (reloadCtx) {
            Expln_utils_promise.promiseMap(reloadCtx(stateLocStor.srcs, state.settings, undefined, undefined), (function (res) {
                    if (res.TAG === "Ok") {
                      return ;
                    }
                    var msg = res._0;
                    Expln_utils_promise.promiseMap(Expln_React_Modal.openModal(modalRef, (function () {
                                return null;
                              })), (function (modalId) {
                            Expln_React_Modal.updateModal(modalRef, modalId, (function () {
                                    return React.createElement(Paper, {
                                                style: {
                                                  padding: "10px"
                                                },
                                                children: Caml_option.some(React.createElement(Expln_React_Column.make, {
                                                          spacing: 1,
                                                          children: Caml_option.some(null)
                                                        }, React.createElement("span", {
                                                              style: {
                                                                fontWeight: "bold"
                                                              }
                                                            }, "Could not reload the context because of the error:"), React.createElement("span", {
                                                              style: {
                                                                color: "red"
                                                              }
                                                            }, msg), React.createElement("span", undefined, "This error happened when loading the context:"), rndSrcDtos(stateLocStor.srcs), React.createElement(Button, {
                                                              onClick: (function (param) {
                                                                  Expln_React_Modal.closeModal(modalRef, modalId);
                                                                }),
                                                              variant: "contained",
                                                              children: "Ok"
                                                            })))
                                              });
                                  }));
                          }));
                  }));
          }));
  };
  props.loadEditorState.current = loadEditorStatePriv;
  var actImportFromJson = function (jsonStr) {
    var errorMsg = MM_wrk_editor_json.readEditorStateFromJsonStr(jsonStr);
    if (errorMsg.TAG === "Ok") {
      loadEditorStatePriv(errorMsg._0);
      return true;
    }
    var errorMsg$1 = errorMsg._0;
    Expln_utils_promise.promiseMap(Expln_React_Modal.openModal(modalRef, (function () {
                return null;
              })), (function (modalId) {
            Expln_React_Modal.updateModal(modalRef, modalId, (function () {
                    return React.createElement(Paper, {
                                style: {
                                  padding: "10px"
                                },
                                children: Caml_option.some(React.createElement(Expln_React_Column.make, {
                                          spacing: 1,
                                          children: Caml_option.some(null)
                                        }, errorMsg$1, React.createElement(Button, {
                                              onClick: (function (param) {
                                                  Expln_React_Modal.closeModal(modalRef, modalId);
                                                }),
                                              variant: "contained",
                                              children: "Ok"
                                            })))
                              });
                  }));
          }));
    return false;
  };
  React.useEffect((function () {
          if (initialStateJsonStr !== undefined) {
            actImportFromJson(initialStateJsonStr);
          }
          
        }), []);
  var actOpenImportFromJsonDialog = function () {
    Expln_utils_promise.promiseMap(Expln_React_Modal.openModal(modalRef, (function () {
                return null;
              })), (function (modalId) {
            Expln_React_Modal.updateModal(modalRef, modalId, (function () {
                    return React.createElement(MM_cmp_import_from_json.make, {
                                onImport: (function (text) {
                                    if (actImportFromJson(text)) {
                                      return Expln_React_Modal.closeModal(modalRef, modalId);
                                    }
                                    
                                  }),
                                onCancel: (function () {
                                    Expln_React_Modal.closeModal(modalRef, modalId);
                                  })
                              });
                  }));
          }));
  };
  var actShowCompletedProof = function () {
    var stmt = MM_wrk_editor.getTheOnlyCheckedStmt(state);
    if (stmt === undefined) {
      return showInfoMsg("A proof is not available", infoAboutGettingCompletedProof);
    }
    if (stmt.typ !== "P") {
      return showInfoMsg("A proof is not available", infoAboutGettingCompletedProof);
    }
    var match = stmt.proofStatus;
    if (match === "Ready") {
      return actExportProof(stmt.id);
    } else {
      return showInfoMsg("A proof is not available", infoAboutGettingCompletedProof);
    }
  };
  var actInlineProof = function () {
    var stmt = MM_wrk_editor.getTheOnlyCheckedStmt(state);
    if (stmt === undefined) {
      return showInfoMsg("Cannot inline proof", "Please select a step you want to inline the proof for.");
    }
    if (stmt.typ !== "P") {
      return showInfoMsg("Cannot inline proof", "Proof inlining is applicable to provable steps only.");
    }
    var match = stmt.src;
    if (match === undefined) {
      return showInfoMsg("Cannot inline proof", infoAboutInliningProof);
    }
    if (typeof match !== "object") {
      return showInfoMsg("Cannot inline proof", infoAboutInliningProof);
    }
    if (match.TAG !== "Assertion") {
      return showInfoMsg("Cannot inline proof", infoAboutInliningProof);
    }
    var label = match.label;
    var args = match.args;
    var proofTreeDto = stmt.proofTreeDto;
    if (proofTreeDto === undefined) {
      return showErrMsg("Internal error", "proofTree is not set.");
    }
    var wrkCtx = state.wrkCtx;
    if (wrkCtx === undefined) {
      return showErrMsg("Internal error", "wrkCtx is not set.");
    }
    var wrkCtx$1 = Caml_option.valFromOption(wrkCtx);
    var progressText = "Inlining proof";
    Expln_utils_promise.promiseMap(Expln_React_Modal.openModal(modalRef, (function () {
                return MM_react_common.rndProgress(progressText, 0, undefined);
              })), (function (modalId) {
            Expln_React_Modal.updateModal(modalRef, modalId, (function () {
                    return MM_react_common.rndProgress(progressText, 0, makeActTerminate(modalId));
                  }));
            return Expln_utils_promise.promiseMap(MM_cmp_pe_frame_full.makeFrameProofData(preCtxData, label, (function (pct) {
                              Expln_React_Modal.updateModal(modalRef, modalId, (function () {
                                      return MM_react_common.rndProgress(progressText, pct, makeActTerminate(modalId));
                                    }));
                            })), (function (frameProofData) {
                          if (frameProofData.TAG === "Ok") {
                            Expln_React_Modal.closeModal(modalRef, modalId);
                            var msg = MM_cmp_pe_frame_full.frameProofDataToStmtsDto(preCtxData, wrkCtx$1, proofTreeDto, args, frameProofData._0);
                            if (msg.TAG !== "Ok") {
                              return showErrMsg("Error", msg._0);
                            }
                            var stmtsDto = msg._0;
                            return setState(function (__x) {
                                        return MM_wrk_editor.addNewStatements(__x, stmtsDto, undefined);
                                      });
                          }
                          Expln_React_Modal.closeModal(modalRef, modalId);
                          showErrMsg("Error", frameProofData._0);
                        }));
          }));
  };
  var actDeleteUnrelatedSteps = function (deleteHyps) {
    notifyEditInTempMode(function () {
          var state$1 = MM_wrk_editor.deleteUnrelatedSteps(state, state.checkedStmtIds.map(function (param) {
                    return param[0];
                  }), deleteHyps);
          if (state$1.TAG !== "Ok") {
            return MM_react_common.openInfoDialog(modalRef, state$1._0, undefined, undefined, undefined, undefined);
          }
          var state$2 = state$1._0;
          setState(function (param) {
                return state$2;
              });
        });
  };
  var actRenumberSteps = function () {
    notifyEditInTempMode(function () {
          var state$1 = MM_wrk_editor.renumberProvableSteps(state);
          if (state$1.TAG !== "Ok") {
            return MM_react_common.openInfoDialog(modalRef, state$1._0, undefined, undefined, undefined, undefined);
          }
          var state$2 = state$1._0;
          setState(function (param) {
                return state$2;
              });
        });
  };
  var actRenameHypotheses = function () {
    notifyEditInTempMode(function () {
          var goalStmt = state.stmts.find(function (stmt) {
                return stmt.isGoal;
              });
          if (goalStmt === undefined) {
            return MM_react_common.openInfoDialog(modalRef, "The goal step is not set. Please mark one of the steps as the goal step.", undefined, undefined, undefined, "Cannot rename hypotheses");
          }
          var state$1 = MM_wrk_editor.renumberHypothesisSteps(state, goalStmt.label);
          if (state$1.TAG !== "Ok") {
            return MM_react_common.openInfoDialog(modalRef, state$1._0, undefined, undefined, undefined, undefined);
          }
          var state$2 = state$1._0;
          setState(function (param) {
                return state$2;
              });
        });
  };
  var actOpenMoveStepsDialog = function () {
    Expln_utils_promise.promiseMap(Expln_React_Modal.openModal(modalRef, (function () {
                return null;
              })), (function (modalId) {
            Expln_React_Modal.updateModal(modalRef, modalId, (function () {
                    return React.createElement(Paper, {
                                style: {
                                  padding: "10px"
                                },
                                children: Caml_option.some(React.createElement(Expln_React_Column.make, {
                                          children: Caml_option.some(null)
                                        }, React.createElement(List, {
                                              disablePadding: true,
                                              children: Caml_option.some(null)
                                            }, React.createElement(ListItem, {
                                                  disablePadding: true,
                                                  children: Caml_option.some(React.createElement(ListItemButton, {
                                                            onClick: (function (param) {
                                                                Expln_React_Modal.closeModal(modalRef, modalId);
                                                                setState(MM_wrk_editor.moveCheckedStmtsToTop);
                                                              }),
                                                            children: Caml_option.some(React.createElement(ListItemText, {
                                                                      children: "Move selected steps to the top"
                                                                    }))
                                                          }))
                                                }), React.createElement(ListItem, {
                                                  disablePadding: true,
                                                  children: Caml_option.some(React.createElement(ListItemButton, {
                                                            onClick: (function (param) {
                                                                Expln_React_Modal.closeModal(modalRef, modalId);
                                                                setState(MM_wrk_editor.moveCheckedStmtsToBottom);
                                                              }),
                                                            children: Caml_option.some(React.createElement(ListItemText, {
                                                                      children: "Move selected steps to the bottom"
                                                                    }))
                                                          }))
                                                })), React.createElement(Expln_React_Row.make, {
                                              children: Caml_option.some(null)
                                            }, React.createElement(Button, {
                                                  onClick: (function (param) {
                                                      Expln_React_Modal.closeModal(modalRef, modalId);
                                                    }),
                                                  variant: "outlined",
                                                  children: "Cancel"
                                                }), MM_react_common.rndHiddenTextField(undefined, MM_react_common.kbrdHnds([MM_react_common.kbrdClbkMake(MM_react_common.keyEsc, undefined, undefined, undefined, (function () {
                                                              Expln_React_Modal.closeModal(modalRef, modalId);
                                                            }))])))))
                              });
                  }));
          }));
  };
  var actOpenViewOptionsDialog = function () {
    Expln_utils_promise.promiseMap(Expln_React_Modal.openModal(modalRef, (function () {
                return null;
              })), (function (modalId) {
            Expln_React_Modal.updateModal(modalRef, modalId, (function () {
                    return React.createElement(MM_cmp_editor_view_options.make, {
                                showCheckbox: showCheckbox,
                                onShowCheckboxChange: (function (b) {
                                    setShowCheckbox(function (param) {
                                          return b;
                                        });
                                  }),
                                showLabel: showLabel,
                                onShowLabelChange: (function (b) {
                                    setShowLabel(function (param) {
                                          return b;
                                        });
                                  }),
                                showType: showType,
                                onShowTypeChange: (function (b) {
                                    setShowType(function (param) {
                                          return b;
                                        });
                                  }),
                                showJstf: showJstf,
                                onShowJstfChange: (function (b) {
                                    setShowJstf(function (param) {
                                          return b;
                                        });
                                  }),
                                inlineMode: inlineMode,
                                onInlineModeChange: (function (b) {
                                    setInlineMode(function (param) {
                                          return b;
                                        });
                                  }),
                                smallBtns: smallBtns,
                                onSmallBtnsChange: (function (b) {
                                    setSmallBtns(function (param) {
                                          return b;
                                        });
                                  }),
                                stepsPerPage: stepsPerPage,
                                onStepsPerPageChange: actSetStepsPerPage,
                                onClose: (function () {
                                    Expln_React_Modal.closeModal(modalRef, modalId);
                                  })
                              });
                  }));
          }));
  };
  var rndError = function (msgOpt, color) {
    if (msgOpt !== undefined) {
      return React.createElement("pre", {
                  style: {
                    color: color,
                    whiteSpace: "pre-wrap"
                  }
                }, msgOpt);
    } else {
      return React.createElement(React.Fragment, {});
    }
  };
  var rndMainMenu = function () {
    if (!mainMenuIsOpened) {
      return null;
    }
    var mainMenuButtonRef$1 = mainMenuButtonRef.current;
    if (mainMenuButtonRef$1 == null) {
      return null;
    } else {
      return React.createElement(Expln_React_Menu.make, {
                  opn: true,
                  anchorEl: Caml_option.some(mainMenuButtonRef$1),
                  onClose: actCloseMainMenu,
                  children: Caml_option.some(null)
                }, React.createElement(MenuItem, {
                      onClick: (function () {
                          setMainMenuIsOpened(function (param) {
                                return false;
                              });
                          setShowTabs(!showTabs);
                        }),
                      children: Caml_option.some(showTabs ? "Hide tabs" : "Show tabs")
                    }), React.createElement(MenuItem, {
                      onClick: (function () {
                          setMainMenuIsOpened(function (param) {
                                return false;
                              });
                          Belt_Option.forEach(Caml_option.nullable_to_opt(toggleCtxSelector.current), (function (toggleCtxSelector) {
                                  toggleCtxSelector();
                                }));
                        }),
                      children: Caml_option.some(ctxSelectorIsExpanded ? "Hide context" : "Show context")
                    }), React.createElement(MenuItem, {
                      onClick: (function () {
                          setMainMenuIsOpened(function (param) {
                                return false;
                              });
                          actOpenViewOptionsDialog();
                        }),
                      children: "View options"
                    }), React.createElement(MenuItem, {
                      onClick: (function () {
                          setMainMenuIsOpened(function (param) {
                                return false;
                              });
                          actExportToUrl();
                        }),
                      children: "Export to URL"
                    }), React.createElement(MenuItem, {
                      onClick: (function () {
                          setMainMenuIsOpened(function (param) {
                                return false;
                              });
                          actExportToJson();
                        }),
                      children: "Export to JSON"
                    }), React.createElement(MenuItem, {
                      onClick: (function () {
                          setMainMenuIsOpened(function (param) {
                                return false;
                              });
                          actOpenImportFromJsonDialog();
                        }),
                      children: "Import from JSON ..."
                    }), React.createElement(MenuItem, {
                      onClick: (function () {
                          setMainMenuIsOpened(function (param) {
                                return false;
                              });
                          setState(MM_wrk_editor.resetEditorContent);
                        }),
                      children: "Reset editor content"
                    }), React.createElement(MenuItem, {
                      onClick: (function () {
                          setMainMenuIsOpened(function (param) {
                                return false;
                              });
                          actShowCompletedProof();
                        }),
                      children: "Show completed proof"
                    }), React.createElement(MenuItem, {
                      onClick: (function () {
                          setMainMenuIsOpened(function (param) {
                                return false;
                              });
                          actInlineProof();
                        }),
                      children: "Inline proof"
                    }), React.createElement(MenuItem, {
                      onClick: (function () {
                          setMainMenuIsOpened(function (param) {
                                return false;
                              });
                          actDeleteUnrelatedSteps(false);
                        }),
                      children: "Delete unrelated steps"
                    }), React.createElement(MenuItem, {
                      onClick: (function () {
                          setMainMenuIsOpened(function (param) {
                                return false;
                              });
                          actDeleteUnrelatedSteps(true);
                        }),
                      children: "Delete unrelated steps and hypotheses"
                    }), React.createElement(MenuItem, {
                      onClick: (function () {
                          setMainMenuIsOpened(function (param) {
                                return false;
                              });
                          actOpenMoveStepsDialog();
                        }),
                      children: "Move steps"
                    }), React.createElement(MenuItem, {
                      onClick: (function () {
                          setMainMenuIsOpened(function (param) {
                                return false;
                              });
                          actRenameHypotheses();
                        }),
                      children: "Rename hypotheses"
                    }), React.createElement(MenuItem, {
                      onClick: (function () {
                          setMainMenuIsOpened(function (param) {
                                return false;
                              });
                          actRenumberSteps();
                        }),
                      children: "Renumber steps"
                    }));
    }
  };
  var actToggleShowBkmOnly = function () {
    setShowBkmOnly(function (prev) {
          return !prev;
        });
    setStatePriv(MM_wrk_editor.uncheckAllStmts);
  };
  var actOpenMacros = function () {
    Expln_utils_promise.promiseMap(Expln_React_Modal.openModal(modalRef, (function () {
                return null;
              })), (function (modalId) {
            Expln_React_Modal.updateModal(modalRef, modalId, (function () {
                    var closeDialog = function () {
                      Expln_React_Modal.closeModal(modalRef, modalId);
                    };
                    return React.createElement(MM_cmp_macros.make, {
                                modalRef: modalRef,
                                onClose: closeDialog
                              });
                  }));
          }));
  };
  var rndButtons = function () {
    return React.createElement(Paper, {
                children: Caml_option.some(React.createElement(Expln_React_Row.make, {
                          spacing: 0,
                          childXsOffset: (function (idx) {
                              if (idx !== 16) {
                                return ;
                              } else {
                                return "auto";
                              }
                            }),
                          children: Caml_option.some(null)
                        }, React.createElement(Checkbox, {
                              style: smallBtns ? ({
                                    padding: "2px"
                                  }) : undefined,
                              disabled: editIsActive,
                              indeterminate: Belt_Option.isNone(mainCheckboxState),
                              checked: Belt_Option.getWithDefault(mainCheckboxState, false),
                              onChange: (function (param) {
                                  actToggleMainCheckbox();
                                })
                            }), rndIconButton(React.createElement(BookmarkAddOutlined, {}), actBookmarkCheckedStmts, !editIsActive && atLeastOneStmtIsChecked && !allCheckedStmtsAreBookmarked, notifyEditInTempMode, undefined, "Bookmark selected steps", smallBtns), rndIconButton(React.createElement(BookmarkRemoveOutlined, {}), actUnbookmarkCheckedStmts, !editIsActive && atLeastOneStmtIsChecked && !allCheckedStmtsAreUnbookmarked, notifyEditInTempMode, undefined, "Unbookmark selected steps", smallBtns), rndIconButton(showBkmOnly ? React.createElement(Bookmark, {}) : React.createElement(BookmarkBorder, {}), actToggleShowBkmOnly, true, undefined, undefined, "Show bookmarked steps only / show all steps", smallBtns), rndIconButton(React.createElement(ArrowDownward, {}), actMoveCheckedStmtsDown, !showBkmOnly && !editIsActive && MM_wrk_editor.canMoveCheckedStmts(state, false), notifyEditInTempMode, undefined, "Move selected steps down", smallBtns), rndIconButton(React.createElement(ArrowUpward, {}), actMoveCheckedStmtsUp, !showBkmOnly && !editIsActive && MM_wrk_editor.canMoveCheckedStmts(state, true), notifyEditInTempMode, undefined, "Move selected steps up", smallBtns), rndIconButton(React.createElement(Add, {}), actAddNewStmt, !editIsActive, notifyEditInTempMode, undefined, "Add new step (and place before selected steps if any)", smallBtns), rndIconButton(React.createElement(DeleteForever, {}), actDeleteCheckedStmts, !editIsActive && atLeastOneStmtIsChecked, notifyEditInTempMode, undefined, "Delete selected steps", smallBtns), rndIconButton(React.createElement(Logout, {
                                  style: {
                                    transform: "rotate(-90deg)"
                                  }
                                }), (function () {
                                actDuplicateStmt(true);
                              }), !editIsActive && MM_wrk_editor.isSingleStmtChecked(state), notifyEditInTempMode, undefined, "Duplicate selected step up", smallBtns), rndIconButton(React.createElement(Logout, {
                                  style: {
                                    transform: "rotate(+90deg)"
                                  }
                                }), (function () {
                                actDuplicateStmt(false);
                              }), !editIsActive && MM_wrk_editor.isSingleStmtChecked(state), notifyEditInTempMode, undefined, "Duplicate selected step down", smallBtns), rndIconButton(React.createElement(Restore, {}), actOpenRestorePrevStateDialog, !editIsActive, notifyEditInTempMode, undefined, "Restore previous state", smallBtns), rndIconButton(React.createElement(MergeType, {
                                  style: {
                                    transform: "rotate(180deg)"
                                  }
                                }), actMergeStmts, numOfCheckedStmts === 1 || thereIsDuplicatedStmt, notifyEditInTempMode, undefined, "Merge two similar steps", smallBtns), rndIconButton(React.createElement(Search, {}), actSearchAsrt, generalModificationActionIsEnabled && MM_substitution.frmsSize(state.frms) > 0, notifyEditInTempMode, undefined, "Add new steps from existing assertions (and place before selected steps if any)", smallBtns), rndIconButton(React.createElement(TextRotationNone, {}), actSubstitute, generalModificationActionIsEnabled, notifyEditInTempMode, undefined, "Apply a substitution to all steps", smallBtns), rndIconButton(React.createElement(Hub, {}), (function () {
                                actUnify(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
                              }), generalModificationActionIsEnabled && state.stmts.length > 0, Belt_Option.isSome(singleProvableChecked) ? notifyEditInTempMode : undefined, undefined, "Unify all steps or unify selected provable bottom-up", smallBtns), rndIconButton(React.createElement(PlayArrow, {}), actOpenMacros, !editIsActive, notifyEditInTempMode, undefined, "Run a macro", smallBtns), rndIconButton(React.createElement(Menu, {}), actOpenMainMenu, !editIsActive, undefined, Caml_option.some(mainMenuButtonRef), "Additional actions", smallBtns)))
              });
  };
  var rndErrors = function (stmt) {
    if (Belt_Option.isSome(stmt.stmtErr) || Belt_Option.isSome(stmt.syntaxErr) || Belt_Option.isSome(stmt.unifErr)) {
      return React.createElement(Expln_React_Column.make, {
                  style: {
                    marginLeft: "10px"
                  },
                  children: Caml_option.some(null)
                }, rndError(Belt_Option.map(stmt.stmtErr, (function (err) {
                            return err.msg;
                          })), "red"), rndError(Belt_Option.map(stmt.syntaxErr, (function (msg) {
                            if (msg === "") {
                              return "Syntax error.";
                            } else {
                              return "Syntax error - " + msg + ".";
                            }
                          })), "red"), rndError(stmt.unifErr, "darkgrey"));
    } else {
      return React.createElement(React.Fragment, {});
    }
  };
  var rndStmt = function (stmt) {
    return React.createElement(MM_cmp_user_stmt.make, {
                modalRef: modalRef,
                settingsVer: state.settingsV,
                settings: state.settings,
                preCtxVer: state.preCtxV,
                varsText: state.varsText,
                wrkCtx: state.wrkCtx,
                frms: state.frms,
                parenCnt: state.parenCnt,
                syntaxTypes: state.syntaxTypes,
                parensMap: state.parensMap,
                typeColors: state.typeColors,
                preCtxColors: state.preCtxColors,
                wrkCtxColors: state.wrkCtxColors,
                editStmtsByLeftClick: state.settings.editStmtsByLeftClick,
                longClickEnabled: state.settings.longClickEnabled,
                longClickDelayMs: state.settings.longClickDelayMs,
                defaultStmtType: state.settings.defaultStmtType,
                showVisByDefault: state.settings.showVisByDefault,
                viewOptions: viewOptions,
                readOnly: false,
                parenAc: parenAc,
                toggleParenAc: actToggleParenAc,
                stmt: stmt,
                onLabelEditRequested: (function () {
                    actBeginEdit(MM_wrk_editor.setLabelEditMode, stmt.id);
                  }),
                onLabelEditDone: (function (newLabel) {
                    actCompleteEditLabel(stmt.id, newLabel);
                  }),
                onLabelEditCancel: (function (newLabel) {
                    var stmtId = stmt.id;
                    var stmt$1 = MM_wrk_editor.editorGetStmtById(state, stmtId);
                    if (stmt$1 === undefined) {
                      return ;
                    }
                    var textOld = stmt$1.label;
                    if (textOld === newLabel || newLabel === "") {
                      return setState(function (__x) {
                                  return MM_wrk_editor.completeLabelEditMode(__x, stmtId, textOld);
                                });
                    } else {
                      Expln_utils_promise.promiseMap(Expln_React_Modal.openModal(modalRef, (function () {
                                  return null;
                                })), (function (modalId) {
                              Expln_React_Modal.updateModal(modalRef, modalId, (function () {
                                      return React.createElement(MM_cmp_save_or_discard.make, {
                                                  contOld: textOld,
                                                  contNew: newLabel,
                                                  onDiscard: (function () {
                                                      Expln_React_Modal.closeModal(modalRef, modalId);
                                                      setState(function (__x) {
                                                            return MM_wrk_editor.completeLabelEditMode(__x, stmtId, textOld);
                                                          });
                                                    }),
                                                  onSave: (function () {
                                                      Expln_React_Modal.closeModal(modalRef, modalId);
                                                      actCompleteEditLabel(stmtId, newLabel);
                                                    }),
                                                  onContinueEditing: (function () {
                                                      Expln_React_Modal.closeModal(modalRef, modalId);
                                                    })
                                                });
                                    }));
                            }));
                      return ;
                    }
                  }),
                onTypEditRequested: (function () {
                    actBeginEdit(MM_wrk_editor.setTypEditMode, stmt.id);
                  }),
                onTypEditDone: (function (newTyp, newIsGoal) {
                    setState(function (__x) {
                          return MM_wrk_editor.completeTypEditMode(__x, stmt.id, newTyp, newIsGoal);
                        });
                  }),
                onContEditRequested: (function () {
                    actBeginEdit(MM_wrk_editor.setContEditMode, stmt.id);
                  }),
                onContEditDone: (function (newContText) {
                    setState(function (__x) {
                          return MM_wrk_editor.completeContEditMode(__x, stmt.id, newContText);
                        });
                  }),
                onContEditCancel: (function (newContText) {
                    var stmtId = stmt.id;
                    var stmt$1 = MM_wrk_editor.editorGetStmtById(state, stmtId);
                    if (stmt$1 === undefined) {
                      return ;
                    }
                    var contOld = stmt$1.cont;
                    var contNew = MM_wrk_editor.strToCont(newContText, undefined, undefined);
                    var textOld = MM_wrk_editor.contToStr(contOld);
                    var textNew = MM_wrk_editor.contToStr(contNew);
                    if (textOld === textNew || textOld === "" && textNew === state.settings.defaultStmtType.trim()) {
                      if (textOld === "") {
                        return setState(function (__x) {
                                    return MM_wrk_editor.deleteStmt(__x, stmtId);
                                  });
                      } else {
                        return setState(function (__x) {
                                    return MM_wrk_editor.completeContEditMode(__x, stmtId, textOld);
                                  });
                      }
                    } else if (textNew === "") {
                      return setState(function (__x) {
                                  return MM_wrk_editor.completeContEditMode(__x, stmtId, textOld);
                                });
                    } else {
                      Expln_utils_promise.promiseMap(Expln_React_Modal.openModal(modalRef, (function () {
                                  return null;
                                })), (function (modalId) {
                              Expln_React_Modal.updateModal(modalRef, modalId, (function () {
                                      return React.createElement(MM_cmp_save_or_discard.make, {
                                                  contOld: MM_cmp_user_stmt.rndContText(contOld, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                                                  removeStmt: textOld === "",
                                                  contNew: MM_cmp_user_stmt.rndContText(contNew, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                                                  onDiscard: (function () {
                                                      Expln_React_Modal.closeModal(modalRef, modalId);
                                                      if (textOld === "") {
                                                        return setState(function (__x) {
                                                                    return MM_wrk_editor.deleteStmt(__x, stmtId);
                                                                  });
                                                      } else {
                                                        return setState(function (__x) {
                                                                    return MM_wrk_editor.completeContEditMode(__x, stmtId, textOld);
                                                                  });
                                                      }
                                                    }),
                                                  onSave: (function () {
                                                      Expln_React_Modal.closeModal(modalRef, modalId);
                                                      setState(function (__x) {
                                                            return MM_wrk_editor.completeContEditMode(__x, stmtId, textNew);
                                                          });
                                                    }),
                                                  onContinueEditing: (function () {
                                                      Expln_React_Modal.closeModal(modalRef, modalId);
                                                    })
                                                });
                                    }));
                            }));
                      return ;
                    }
                  }),
                onSyntaxTreeUpdatedWithoutContentChange: (function (newStmtCont) {
                    setStatePriv(function (__x) {
                          return MM_wrk_editor.setStmtCont(__x, stmt.id, newStmtCont);
                        });
                  }),
                onJstfEditRequested: (function () {
                    actBeginEdit(MM_wrk_editor.setJstfEditMode, stmt.id);
                  }),
                onJstfEditDone: (function (newJstf) {
                    setState(function (__x) {
                          return MM_wrk_editor.completeJstfEditMode(__x, stmt.id, newJstf);
                        });
                  }),
                onJstfEditCancel: (function (newJstf) {
                    var stmtId = stmt.id;
                    var stmt$1 = MM_wrk_editor.editorGetStmtById(state, stmtId);
                    if (stmt$1 === undefined) {
                      return ;
                    }
                    var match = stmt$1.typ;
                    var textOld;
                    textOld = match === "E" ? MM_wrk_editor.defaultJstfForHyp : stmt$1.jstfText.trim();
                    var newJstfTextTrim = newJstf.trim();
                    var match$1 = stmt$1.typ;
                    var textNew;
                    textNew = match$1 === "E" && MM_wrk_editor.defaultJstfForHyp === newJstfTextTrim.toUpperCase() ? MM_wrk_editor.defaultJstfForHyp : newJstfTextTrim;
                    var nothingChanged = textOld === textNew;
                    if (nothingChanged) {
                      return setState(function (__x) {
                                  return MM_wrk_editor.completeJstfEditMode(__x, stmtId, textOld);
                                });
                    } else {
                      Expln_utils_promise.promiseMap(Expln_React_Modal.openModal(modalRef, (function () {
                                  return null;
                                })), (function (modalId) {
                              Expln_React_Modal.updateModal(modalRef, modalId, (function () {
                                      return React.createElement(MM_cmp_save_or_discard.make, {
                                                  contOld: textOld,
                                                  contNew: textNew,
                                                  onDiscard: (function () {
                                                      Expln_React_Modal.closeModal(modalRef, modalId);
                                                      setState(function (__x) {
                                                            return MM_wrk_editor.completeJstfEditMode(__x, stmtId, textOld);
                                                          });
                                                    }),
                                                  onSave: (function () {
                                                      Expln_React_Modal.closeModal(modalRef, modalId);
                                                      setState(function (__x) {
                                                            return MM_wrk_editor.completeJstfEditMode(__x, stmtId, textNew);
                                                          });
                                                    }),
                                                  onContinueEditing: (function () {
                                                      Expln_React_Modal.closeModal(modalRef, modalId);
                                                    })
                                                });
                                    }));
                            }));
                      return ;
                    }
                  }),
                checkboxDisabled: editIsActive,
                checkboxChecked: MM_wrk_editor.isStmtChecked(state, stmt.id),
                checkboxOnChange: (function (param) {
                    var id = stmt.id;
                    setStatePriv(function (st) {
                          return MM_wrk_editor.toggleStmtChecked(st, id);
                        });
                  }),
                onGenerateProof: (function () {
                    actExportProof(stmt.id);
                  }),
                onDebug: (function () {
                    notifyEditInTempMode(function () {
                          var stmtId = stmt.id;
                          var st = MM_wrk_editor.uncheckAllStmts(state);
                          var st$1 = MM_wrk_editor.toggleStmtChecked(st, stmtId);
                          var stmt$1 = MM_wrk_editor.getTheOnlyCheckedStmt(st$1);
                          var singleProvableChecked = stmt$1 !== undefined && stmt$1.typ === "P" ? stmt$1 : undefined;
                          if (singleProvableChecked === undefined) {
                            return ;
                          }
                          var rootUserStmts = MM_wrk_editor.getRootStmtsForUnification(st$1);
                          var rootStmts = rootUserStmts.map(MM_wrk_editor.userStmtToRootStmt);
                          var match = getArgs0AndAsrtLabel([singleProvableChecked], rootStmts);
                          var match$1 = match !== undefined ? [
                              MM_provers.bottomUpProverParamsMakeDefault(match[1], 1, "Less", false, false, false, match[0], [], undefined),
                              2
                            ] : [
                              MM_provers.bottomUpProverParamsMakeDefault(undefined, 1, "No", false, false, false, rootStmts.map(function (stmt) {
                                        return stmt.expr;
                                      }), [], undefined),
                              1
                            ];
                          actUnify(stmtId, match$1[0], match$1[1], undefined, undefined, undefined, undefined, undefined);
                        });
                  }),
                addStmtAbove: (function (text) {
                    var id = stmt.id;
                    var isBkm = stmt.isBkm || showBkmOnly && stmt.typ === "E";
                    setState(function (st) {
                          var st$1 = addStmtAbove(st, id, text, isBkm);
                          return MM_wrk_editor.uncheckAllStmts(st$1);
                        });
                  }),
                addStmtBelow: (function (text) {
                    var id = stmt.id;
                    var isBkm = stmt.isBkm || showBkmOnly && stmt.typ === "E";
                    setState(function (st) {
                          var st$1 = addStmtAbove(st, id, text, isBkm);
                          var st$2 = MM_wrk_editor.moveCheckedStmts(st$1, true);
                          return MM_wrk_editor.uncheckAllStmts(st$2);
                        });
                  }),
                setShowTabs: setShowTabs,
                openFrameExplorer: openFrameExplorer
              });
  };
  var rndStmtAndErrors = function (stmt) {
    return JsxPPXReactSupportU.createElementVariadicWithKey(stmt.id, Expln_React_Column.make, {
                spacing: 0,
                children: Caml_option.some(null)
              }, [
                rndStmt(stmt),
                rndErrors(stmt)
              ]);
  };
  var rndDescr = function () {
    return React.createElement(Expln_React_Row.make, {
                alignItems: "flex-start",
                spacing: 1,
                style: {
                  marginTop: "12px",
                  marginLeft: "7px"
                },
                children: Caml_option.some(null)
              }, React.createElement("span", {
                    style: {
                      cursor: "pointer"
                    },
                    onClick: (function (param) {
                        actBeginEdit0(MM_wrk_editor.setDescrEditMode);
                      })
                  }, "Description"), React.createElement(Expln_React_Column.make, {
                    children: Caml_option.some(React.createElement(MM_cmp_multiline_text.make, {
                              text: state.descr,
                              editMode: state.descrEditMode,
                              onEditRequested: (function () {
                                  actBeginEdit0(MM_wrk_editor.setDescrEditMode);
                                }),
                              onEditDone: actDescrEditComplete,
                              onEditCancel: (function (newText) {
                                  var textOld = state.descr.trim();
                                  var textNew = newText.trim();
                                  if (textOld === textNew || textNew === "") {
                                    return setState(function (__x) {
                                                return MM_wrk_editor.completeDescrEditMode(__x, textOld);
                                              });
                                  } else {
                                    Expln_utils_promise.promiseMap(Expln_React_Modal.openModal(modalRef, (function () {
                                                return null;
                                              })), (function (modalId) {
                                            Expln_React_Modal.updateModal(modalRef, modalId, (function () {
                                                    return React.createElement(MM_cmp_save_or_discard.make, {
                                                                contOld: React.createElement("pre", undefined, textOld),
                                                                contNew: React.createElement("pre", undefined, textNew),
                                                                onDiscard: (function () {
                                                                    Expln_React_Modal.closeModal(modalRef, modalId);
                                                                    setState(function (__x) {
                                                                          return MM_wrk_editor.completeDescrEditMode(__x, textOld);
                                                                        });
                                                                  }),
                                                                onSave: (function () {
                                                                    Expln_React_Modal.closeModal(modalRef, modalId);
                                                                    setState(function (__x) {
                                                                          return MM_wrk_editor.completeDescrEditMode(__x, textNew);
                                                                        });
                                                                  }),
                                                                onContinueEditing: (function () {
                                                                    Expln_React_Modal.closeModal(modalRef, modalId);
                                                                  })
                                                              });
                                                  }));
                                          }));
                                    return ;
                                  }
                                }),
                              editByClick: false,
                              editByAltClick: true,
                              longClickEnabled: state.settings.longClickEnabled,
                              longClickDelayMs: state.settings.longClickDelayMs,
                              renderer: (function (str) {
                                  return React.createElement(Static_XML_to_HTML.make, {
                                              xmlStr: str
                                            });
                                }),
                              fullWidth: true,
                              onHelp: (function () {
                                  Expln_utils_promise.promiseMap(Expln_React_Modal.openModal(modalRef, (function () {
                                              return null;
                                            })), (function (modalId) {
                                          Expln_React_Modal.updateModal(modalRef, modalId, (function () {
                                                  return React.createElement(XML_formatting_help.make, {
                                                              onClose: (function () {
                                                                  Expln_React_Modal.closeModal(modalRef, modalId);
                                                                })
                                                            });
                                                }));
                                        }));
                                }),
                              onDelete: (function () {
                                  actDescrEditComplete("");
                                })
                            }))
                  }));
  };
  var rndVars = function () {
    return React.createElement(Expln_React_Row.make, {
                alignItems: "flex-start",
                spacing: 1,
                style: {
                  marginTop: "3px",
                  marginLeft: "7px"
                },
                children: Caml_option.some(null)
              }, React.createElement("span", {
                    style: {
                      cursor: "pointer"
                    },
                    onClick: (function (param) {
                        actBeginEdit0(MM_wrk_editor.setVarsEditMode);
                      })
                  }, "Variables"), React.createElement(Expln_React_Column.make, {
                    children: Caml_option.some(null)
                  }, React.createElement(MM_cmp_multiline_text.make, {
                        text: state.varsText,
                        editMode: state.varsEditMode,
                        onEditRequested: (function () {
                            actBeginEdit0(MM_wrk_editor.setVarsEditMode);
                          }),
                        onEditDone: actVarsEditComplete,
                        onEditCancel: (function (newText) {
                            var textOld = state.varsText.trim();
                            var textNew = newText.trim();
                            if (textOld === textNew || textNew === "") {
                              return setState(function (__x) {
                                          return MM_wrk_editor.completeVarsEditMode(__x, textOld);
                                        });
                            } else {
                              Expln_utils_promise.promiseMap(Expln_React_Modal.openModal(modalRef, (function () {
                                          return null;
                                        })), (function (modalId) {
                                      Expln_React_Modal.updateModal(modalRef, modalId, (function () {
                                              return React.createElement(MM_cmp_save_or_discard.make, {
                                                          contOld: React.createElement("pre", undefined, textOld),
                                                          contNew: React.createElement("pre", undefined, textNew),
                                                          onDiscard: (function () {
                                                              Expln_React_Modal.closeModal(modalRef, modalId);
                                                              setState(function (__x) {
                                                                    return MM_wrk_editor.completeVarsEditMode(__x, textOld);
                                                                  });
                                                            }),
                                                          onSave: (function () {
                                                              Expln_React_Modal.closeModal(modalRef, modalId);
                                                              setState(function (__x) {
                                                                    return MM_wrk_editor.completeVarsEditMode(__x, textNew);
                                                                  });
                                                            }),
                                                          onContinueEditing: (function () {
                                                              Expln_React_Modal.closeModal(modalRef, modalId);
                                                            })
                                                        });
                                            }));
                                    }));
                              return ;
                            }
                          }),
                        editByClick: true,
                        editByAltClick: true,
                        longClickEnabled: state.settings.longClickEnabled,
                        longClickDelayMs: state.settings.longClickDelayMs,
                        onDelete: (function () {
                            actVarsEditComplete("");
                          })
                      }), rndError(state.varsErr, "red")));
  };
  var rndDisj = function () {
    return React.createElement(Expln_React_Row.make, {
                alignItems: "flex-start",
                spacing: 1,
                style: {
                  marginLeft: "7px"
                },
                children: Caml_option.some(null)
              }, React.createElement("span", {
                    style: {
                      cursor: "pointer"
                    },
                    onClick: (function (param) {
                        actBeginEdit0(MM_wrk_editor.setDisjEditMode);
                      })
                  }, "Disjoints"), React.createElement(Expln_React_Column.make, {
                    children: Caml_option.some(null)
                  }, React.createElement(MM_cmp_multiline_text.make, {
                        text: state.disjText,
                        editMode: state.disjEditMode,
                        onEditRequested: (function () {
                            actBeginEdit0(MM_wrk_editor.setDisjEditMode);
                          }),
                        onEditDone: actDisjEditComplete,
                        onEditCancel: (function (newText) {
                            var textOld = state.disjText.trim();
                            var textNew = newText.trim();
                            if (textOld === textNew || textNew === "") {
                              return setState(function (__x) {
                                          return MM_wrk_editor.completeDisjEditMode(__x, textOld);
                                        });
                            } else {
                              Expln_utils_promise.promiseMap(Expln_React_Modal.openModal(modalRef, (function () {
                                          return null;
                                        })), (function (modalId) {
                                      Expln_React_Modal.updateModal(modalRef, modalId, (function () {
                                              return React.createElement(MM_cmp_save_or_discard.make, {
                                                          contOld: React.createElement("pre", undefined, textOld),
                                                          contNew: React.createElement("pre", undefined, textNew),
                                                          onDiscard: (function () {
                                                              Expln_React_Modal.closeModal(modalRef, modalId);
                                                              setState(function (__x) {
                                                                    return MM_wrk_editor.completeDisjEditMode(__x, textOld);
                                                                  });
                                                            }),
                                                          onSave: (function () {
                                                              Expln_React_Modal.closeModal(modalRef, modalId);
                                                              setState(function (__x) {
                                                                    return MM_wrk_editor.completeDisjEditMode(__x, textNew);
                                                                  });
                                                            }),
                                                          onContinueEditing: (function () {
                                                              Expln_React_Modal.closeModal(modalRef, modalId);
                                                            })
                                                        });
                                            }));
                                    }));
                              return ;
                            }
                          }),
                        editByClick: true,
                        editByAltClick: true,
                        longClickEnabled: state.settings.longClickEnabled,
                        longClickDelayMs: state.settings.longClickDelayMs,
                        onDelete: (function () {
                            actDisjEditComplete("");
                          })
                      }), rndError(state.disjErr, "red")));
  };
  var getPagesWithErrors = function () {
    var pageHasErrors = function (pageIdx) {
      var minIdx = Math.imul(pageIdx, stepsPerPage);
      var maxIdx = (minIdx + stepsPerPage | 0) - 1 | 0;
      return stmtsToShow.findIndex(function (stmt, i) {
                  if (minIdx <= i && i <= maxIdx) {
                    return MM_wrk_editor.userStmtHasAnyErrors(stmt);
                  } else {
                    return false;
                  }
                }) >= 0;
    };
    return Belt_Array.range(0, maxPageIdx).filter(pageHasErrors);
  };
  var actGoToNextPageWithErrors = function () {
    var pagesWithErrors = getPagesWithErrors();
    if (pagesWithErrors.length <= 0) {
      return ;
    }
    var i = getPagesWithErrors().find(function (i) {
          return pageIdx < i;
        });
    if (i !== undefined) {
      return setPageIdx(function (param) {
                  return i;
                });
    }
    var pageIdx$1 = pagesWithErrors[0];
    setPageIdx(function (param) {
          return pageIdx$1;
        });
  };
  var actGoToPrevPageWithErrors = function () {
    var pagesWithErrors = getPagesWithErrors();
    if (pagesWithErrors.length <= 0) {
      return ;
    }
    var i = getPagesWithErrors().find(function (i) {
          return i < pageIdx;
        });
    if (i !== undefined) {
      return setPageIdx(function (param) {
                  return i;
                });
    }
    var pageIdx$1 = pagesWithErrors[pagesWithErrors.length - 1 | 0];
    setPageIdx(function (param) {
          return pageIdx$1;
        });
  };
  var paginationIsRequired = stmtsToShow.length > stepsPerPage;
  var rndPagination = function () {
    if (paginationIsRequired) {
      return React.createElement("div", {
                  style: {
                    padding: "5px"
                  }
                }, React.createElement(PaginationCmp.make, {
                      numOfPages: numOfPages,
                      pageIdx: pageIdx,
                      siblingCount: 1000,
                      itemsPerPage: stepsPerPage,
                      showGoToPage: false,
                      showItemsPerPage: false,
                      onPageIdxChange: actGoToPage
                    }));
    } else {
      return null;
    }
  };
  var rndGoToNextPageWithErrorsBtn = function () {
    if (thereAreAnyErrorsInEditor && paginationIsRequired) {
      return React.createElement(Expln_React_Row.make, {
                  style: {
                    padding: "5px"
                  },
                  children: Caml_option.some(null)
                }, MM_react_common.rndSmallTextBtn(actGoToPrevPageWithErrors, "< Go to previos page with errors", "red"), MM_react_common.rndSmallTextBtn(actGoToNextPageWithErrors, "Go to next page with errors >", "red"));
    } else {
      return null;
    }
  };
  var rndStmts = function () {
    return React.createElement(Expln_React_Column.make, {
                spacing: 0,
                children: Caml_option.some(null)
              }, rndPagination(), rndGoToNextPageWithErrorsBtn(), stmtsToShow.filter(function (param, i) {
                      if (stmtBeginIdx <= i) {
                        return i <= stmtEndIdx;
                      } else {
                        return false;
                      }
                    }).map(rndStmtAndErrors), rndGoToNextPageWithErrorsBtn(), rndPagination());
  };
  var rndFooter = function () {
    return Belt_Array.range(1, 12).map(function (i) {
                return React.createElement("span", {
                            key: String(i),
                            style: {
                              fontSize: "20px"
                            }
                          }, Common.nbsp);
              });
  };
  var rndShowContentBtn = function () {
    return React.createElement(Expln_React_Column.make, {
                spacing: 1.0,
                style: {
                  padding: "20px"
                },
                children: Caml_option.some(null)
              }, "Editor content is hidden.", React.createElement(Button, {
                    onClick: (function (param) {
                        setContIsHidden(function (param) {
                              return false;
                            });
                      }),
                    variant: "contained",
                    children: "Show editor content"
                  }));
  };
  var actSetStateFromApi = function (update) {
    return Expln_utils_promise.promise(function (resolve) {
                setState(function (st) {
                      var msg = update(st);
                      if (msg.TAG === "Ok") {
                        var match = msg._0;
                        var json = match[1];
                        return MM_wrk_editor.setNextAction(match[0], {
                                    TAG: "Action",
                                    _0: (function () {
                                        resolve({
                                              TAG: "Ok",
                                              _0: json
                                            });
                                      })
                                  });
                      }
                      var msg$1 = msg._0;
                      return MM_wrk_editor.setNextAction(st, {
                                  TAG: "Action",
                                  _0: (function () {
                                      resolve({
                                            TAG: "Error",
                                            _0: msg$1
                                          });
                                    })
                                });
                    });
              });
  };
  var actBuildSyntaxTrees = function (exprs) {
    var wrkCtx = state.wrkCtx;
    if (wrkCtx === undefined) {
      return {
              TAG: "Error",
              _0: "There are errors in the editor."
            };
    }
    var wrkCtx$1 = Caml_option.valFromOption(wrkCtx);
    var syms = exprs.map(Common.getSpaceSeparatedValuesAsArray);
    var unrecognizedSymbol = Belt_HashSetString.toArray(Belt_HashSetString.fromArray(Expln_utils_common.arrFlatMap(syms, (function (a) {
                      return a;
                    })))).find(function (sym) {
          return Belt_Option.isNone(MM_context.ctxSymToInt(wrkCtx$1, sym));
        });
    if (unrecognizedSymbol !== undefined) {
      return {
              TAG: "Error",
              _0: "Unrecognized symbol '" + unrecognizedSymbol + "'"
            };
    } else {
      return MM_wrk_editor.textToSyntaxTree(wrkCtx$1, syms, state.syntaxTypes, state.frms, state.settings.allowedFrms.inSyntax, state.parenCnt, undefined, (function (param) {
                    
                  }));
    }
  };
  var actSetEditorContIsHidden = function (contIsHidden) {
    setContIsHidden(function (param) {
          return contIsHidden;
        });
    return Expln_utils_promise.promiseResolved();
  };
  var showInfoMsgForApi = function (msg) {
    MM_react_common.openInfoDialog(modalRef, undefined, Caml_option.some(React.createElement("pre", undefined, msg)), undefined, undefined, undefined);
  };
  var showErrMsgForApi = function (msg) {
    MM_react_common.openInfoDialog(modalRef, undefined, Caml_option.some(React.createElement("pre", undefined, msg)), Caml_option.some(React.createElement("span", {
                  style: {
                    color: "red"
                  }
                }, React.createElement(PriorityHigh, {}))), undefined, undefined);
  };
  MM_cmp_api.updateEditorApi(state, showInfoMsgForApi, showErrMsgForApi, actSetStateFromApi, actSetEditorContIsHidden, generalModificationActionIsEnabled, (function (params) {
          return Expln_utils_promise.promise(function (resolve) {
                      actUnify(params.stmtId, params.bottomUpProverParams, params.debugLevel, true, params.delayBeforeStartMs, params.selectFirstFoundProof, (function (stmtsDto) {
                              if (!params.selectFirstFoundProof) {
                                return ;
                              }
                              if (stmtsDto === undefined) {
                                return resolve(undefined);
                              }
                              var len = stmtsDto.stmts.length;
                              if (len === 0) {
                                return Js_exn.raiseError("bottom-up prover returned stmtsDto.stmts->Array.length == 0.");
                              } else {
                                return resolve(stmtsDto.stmts[len - 1 | 0].isProved);
                              }
                            }), undefined);
                      if (!params.selectFirstFoundProof) {
                        return resolve(undefined);
                      }
                      
                    });
        }), generalModificationActionIsEnabled, (function () {
          return Expln_utils_promise.promise(function (resolve) {
                      setState(function (st) {
                            var st$1 = MM_wrk_editor.uncheckAllStmts(st);
                            return MM_wrk_editor.setNextAction(st$1, {
                                        TAG: "UnifyAll",
                                        nextAction: (function () {
                                            resolve();
                                          })
                                      });
                          });
                    });
        }), actBuildSyntaxTrees);
  return React.createElement(Expln_React_ContentWithStickyHeader.make, {
              top: props.top,
              header: rndButtons(),
              content: (function (param) {
                  return React.createElement(Expln_React_Column.make, {
                              spacing: 0,
                              children: Caml_option.some(null)
                            }, rndMainMenu(), contIsHidden ? rndShowContentBtn() : React.createElement(Expln_React_Column.make, {
                                    spacing: 0,
                                    children: Caml_option.some(null)
                                  }, rndDescr(), rndVars(), rndDisj(), rndStmts(), rndFooter()));
                })
            });
}

var make = MM_cmp_editor;

exports.editorSaveStateToLocStor = editorSaveStateToLocStor;
exports.editorHistRegLocStorKey = editorHistRegLocStorKey;
exports.editorHistTmpLocStorKey = editorHistTmpLocStorKey;
exports.getHistLockStorKey = getHistLockStorKey;
exports.histSaveToLocStor = histSaveToLocStor;
exports.histReadFromLocStor = histReadFromLocStor;
exports.rndIconButton = rndIconButton;
exports.editorStateLocStorKey = editorStateLocStorKey;
exports.lastUsedAsrtSearchTypLocStorKey = lastUsedAsrtSearchTypLocStorKey;
exports.saveLastUsedTyp = saveLastUsedTyp;
exports.getLastUsedTyp = getLastUsedTyp;
exports.jsonStrOptToEditorStateLocStor = jsonStrOptToEditorStateLocStor;
exports.previousEditingIsNotCompletedTitle = previousEditingIsNotCompletedTitle;
exports.previousEditingIsNotCompletedText = previousEditingIsNotCompletedText;
exports.editingInTempModeTitle = editingInTempModeTitle;
exports.editingInTempModeText = editingInTempModeText;
exports.infoAboutGettingCompletedProof = infoAboutGettingCompletedProof;
exports.infoAboutInliningProof = infoAboutInliningProof;
exports.make = make;
/* react Not a pure module */
